import IndexMap from "../map";
import Alert from '@mui/material/Alert';

const Home = () => {
  return (
    <div>
      <title>Surfwetter</title>
      <div className="App">
        <div className="Content">
          <IndexMap />
          <br />
          <Alert severity="info">Diese Seite befindet sich noch in Entwicklung. Wenn ihr Fehler findet oder euren Lieblingsspot vermisst könnt ihr mich unter <a href="mailto:info@surfwetter.ch">info@surfwetter.ch</a> erreichen</Alert>
        </div>
      </div>
    </div>
  );
};

export default Home;
